import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Base64ToBlobService {

  constructor() { }

  openBase64(base64: string, type: string): void {
    const data = this.base64ToBlob(base64, type);
    const fileURL = URL.createObjectURL(data);
    window.open(fileURL, '_blank');
  }

  base64ToBlob(base64: string, type: string): Blob {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    let mimeType = '';
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    if (type.toLowerCase() === 'pdf') {
      mimeType = 'application/pdf';
    } else if (type.toLowerCase() === 'png') {
      mimeType = 'image/png';
    } else if (type.toLowerCase() === 'jpeg' || type.toLowerCase() === 'jpg') {
      mimeType = 'image/jpeg';
    }
    return new Blob([bytes], { type: mimeType })
  }
}
